<div  class="irb-custom-group-header" style="display: flex; align-items: center;">
  <div class="customHeaderLabel">
    <span tooltip [tooltipTitle]="params.displayName" [tooltipPosition]="'right'" [tooltipRequiresTruncation]='true' [tooltipHorizontalOffset]='0'>{{ params.displayName }}</span>
  </div>
  @if (params.irbColInfo) {
    <div class="ag-header-irb-col-info">
      <div class="infoIcon" calltoaction [calltoactionMaxWidth]="maxWidth" [calltoactionTemplate]="irbColInfoTemplateRef"></div>
    </div>
  }
  <ng-template #irbColInfoTemplateRef ><div [innerHTML]="irbColInfo"></div></ng-template>
</div>

